// extracted by mini-css-extract-plugin
export default {"header":"XeStNTucOrBXAS3hS9Og","title":"Hm248wXy0GjD9zg_N4hg","controls":"eNv93cHTldFWLAw9LsRR","pager":"WZyTvT0rbF0e_Q1dmm3e"};